<router-outlet></router-outlet>


<div style="margin: 10px 10px 10px 10px;">
    <div class="row">
        <div class="col-7">
            <table>
                <td>
                    <img src="../assets/images/s3_logo.png" style="height: 7vh;">
                </td>
                <td>
                    <p class="estiloTitulo">S3 Contact Center</p>
                    <div class="row" *ngIf="data_user && data_user.id">
                        <div *ngIf="socket_services.currentCampaign && socket_services.currentCampaign.url_queue_list"
                            class="col-auto">
                            <button class="btn btn-primary " (click)="showOrHideQueues()">
                                <div class="row" style="margin: 0px;">
                                    <div>
                                        <p style="margin-bottom: 0px">Activar Colas <i
                                                class="fas fa-angle-double-right"></i></p>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-primary " (click)="showOrHideCallbacks()" data-toggle="modal"
                                data-target="#exampleModalLong">
                                <div class="row" style="margin: 0px;">
                                    <div>
                                        <p style="margin-bottom: 0px">Mis Agendamientos<i
                                                class="fas fa-angle-double-right"></i></p>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-primary " (click)="showOrHideSales()" data-toggle="modal"
                                data-target="#modalSales">
                                <div class="row" style="margin: 0px;">
                                    <div>
                                        <p style="margin-bottom: 0px">Mis Ventas<i
                                                class="fas fa-angle-double-right"></i></p>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div *ngIf="socket_services.conversations.length > 0 && socket_services.conversations[0].id && socket_services.conversations[0].mediaType != 'call-inbound'"
                            class="col-auto">
                            <button class="btn btn-primary " data-toggle="modal" data-target="#modalCallbacks">
                                <div class="row" style="margin: 0px;">
                                    <div>
                                        <p style="margin-bottom: 0px">Agendamientos del contacto<i
                                                class="fas fa-angle-double-right"></i></p>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="showQueues && socket_services.currentCampaign.url_queue_list"
                        class="card box stack-top">
                        <div class="row">
                            <div class="col-6 card" style="align-items: baseline;">
                                <p class="estiloTimer">Activas</p>
                                <ng-container *ngFor="let queue of data_user.queues">
                                    <hr *ngIf="queue.joined" style="border:0.5px solid #565659; width: 100%;"
                                        class="estiloObservaciones">
                                    <button *ngIf="queue.joined" class="btn buttonQueue" (click)="setStateQueue(queue)">
                                        <div class="row" style="width: 100%;">
                                            <div>
                                                <p class="pButtonQueue">{{queue.name}}</p>
                                            </div>
                                            <div style="margin-left:auto;margin-right:0;"><i
                                                    class="fas fa-caret-right"></i></div>
                                        </div>
                                    </button>
                                </ng-container>
                            </div>
                            <div class="col-6 card" style="align-items: baseline;">
                                <p class="estiloTimer">Disponibles</p>
                                <ng-container *ngFor="let queue of data_user.queues">
                                    <hr *ngIf="!queue.joined" style="border:0.5px solid #565659; width: 100%;"
                                        class="estiloObservaciones">
                                    <button *ngIf="!queue.joined" class="btn buttonQueue"
                                        (click)="setStateQueue(queue)">
                                        <div class="row" style="width: 100%;">
                                            <div style="margin-right:auto;margin-left:0;"><i
                                                    class="fas fa-caret-left"></i></div>
                                            <div>
                                                <p class="pButtonQueue">{{queue.name}}</p>
                                            </div>
                                        </div>
                                    </button>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                </td>
            </table>
            <!-- <img src=""> -->
        </div>
        <div class="col-2">
            <p><strong>Estado Agente:</strong> {{socket_services.currentPresence.languageLabels.es}}</p>
            <select name="estado_agente" id="estado_agente" [(ngModel)]="presence_select" (change)="changePresence()">
                <option *ngFor="let item of presences" [value]="item.id">{{item.languageLabels.es}}</option>
            </select>
        </div>
        <div class="col-2">
            <p><strong>ELEGIBLE:</strong> {{routing_status}}</p>
            <button
                *ngIf="routing_status!='ELEGIBLE A LLAMADOS' && routing_status!='INTERACTUANDO' && socket_services.currentPresence.systemPresence =='On Queue'"
                class="btn btn-danger estiloBoton" (click)="makeEligibleForInteactions()" style="height: 40px;">Hacer
                Elegible</button>

        </div>
        <div class="col-1">
            <button class="btn btn-primary estiloBoton" (click)="logout()">
                <i class="fas fa-sign-out-alt" style="font-size: 20px;"></i>
                <p>Cerrar Sesión</p>
            </button>
        </div>

    </div>

    <div class="row" style="width: 100%;margin: 15px;">
        <ng-container
            *ngIf="socket_services.conversations.length > 0 && socket_services.conversations[0].id && socket_services.conversations[0].id!='' ">
            <div class="row callInfo">
                <div class="col-9">
                    <h4 class="estiloInteraccion">Id. Interacción: {{socket_services.conversations[0].id}}</h4>
                    <h4 class="estiloInteraccion">N° Telefono:
                        {{socket_services.conversations[0].customer.phone}}</h4>
                </div>

                <div class="col-3 cardTiempo">
                    <h5 class="estiloTimer">Duración Llamada</h5>
                    <p class="estiloTimer">{{callTime}}</p>
                </div>
                <hr class="separador" style="    margin: 1px;">
                <div *ngIf="socket_services.conversations[socket_services.conversations.length-1].state=='alerting'"
                    class="col-1">
                    <button class="btn btn-success estiloBoton"
                        (click)="answerCall(socket_services.conversations[socket_services.conversations.length-1])">
                        <i class="fas fa-phone-volume estiloIcono"></i>
                        <p>Contestar Registro</p>
                    </button>
                </div>
                <div *ngIf="socket_services.conversations[socket_services.conversations.length-1].state=='alerting'"
                    class="col-1 float-right" style="float: right;">
                    <button class="btn btn-warning estiloBoton"
                        (click)="skip(socket_services.conversations[socket_services.conversations.length-1])">
                        <i class="fas fa-forward estiloIcono"></i>
                        <p>Saltar Registro</p>
                    </button>
                </div>
                <ng-container
                    *ngIf="socket_services.conversations[socket_services.conversations.length-1].state=='connected' && !socket_services.conversations[socket_services.conversations.length-1].agentParticipant.calls">
                    <div class="col-2">
                        <p style="margin-bottom: 0px !important;padding-bottom: 0px !important;">Número a
                            llamar: </p>
                        <select style="width: 100%;" *ngIf="socket_services.conversations[0].currentContact"
                            name="phoneList" [(ngModel)]="socket_services.phoneSelected">
                            <option value=''>Seleccionar Número</option>
                            <option *ngFor="let item of socket_services.conversations[0].phoneList" [value]='item'>
                                {{item}}</option>
                        </select>
                    </div>
                    <div class="col-1">
                        <button class="btn btn-success estiloBoton"
                            (click)="socket_services.makeCallPreview(socket_services.conversations[socket_services.conversations.length-1])"
                            [disabled]='!socket_services.phoneSelected'>
                            <i class="fas fa-phone estiloIcono"></i>
                            <p>Llamar Registro</p>
                        </button>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="socket_services.conversations[socket_services.conversations.length-1].state=='connected' && socket_services.conversations[socket_services.conversations.length-1].agentParticipant.calls">
                    <div *ngIf="socket_services.conversations[0].currentCampaignLambda.url_mute" class="col-1">
                        <button *ngIf="socket_services.conversations[socket_services.conversations.length-1].muted"
                            class="btn btn-primary estiloBoton"
                            (click)="muteAudio(socket_services.conversations[socket_services.conversations.length-1])">
                            <i class="fas fa-microphone-slash estiloIcono"></i>
                            <p>Desmutear</p>
                        </button>
                        <button *ngIf="!socket_services.conversations[socket_services.conversations.length-1].muted"
                            class="btn btn-primary estiloBoton"
                            (click)="muteAudio(socket_services.conversations[socket_services.conversations.length-1])">
                            <i class="fas fa-microphone estiloIcono"></i>
                            <p>Mutear</p>
                        </button>
                    </div>

                    <br>
                    <div *ngIf="socket_services.conversations[0].currentCampaignLambda.url_hold" class="col-1">
                        <button *ngIf="socket_services.conversations[socket_services.conversations.length-1].held"
                            class="btn btn-primary estiloBoton"
                            (click)="heldAudio(socket_services.conversations[socket_services.conversations.length-1])">
                            <i class="fas fa-pause estiloIcono"></i>
                            <p>Sacar Música</p>
                        </button>
                        <button *ngIf="!socket_services.conversations[socket_services.conversations.length-1].held"
                            class="btn btn-primary estiloBoton"
                            (click)="heldAudio(socket_services.conversations[socket_services.conversations.length-1])">
                            <i class="fas fa-play estiloIcono"></i>
                            <p>Poner Música</p>
                        </button>
                    </div>
                    <ng-container *ngIf="socket_services.conversations[0].currentCampaignLambda.url_metadata 
                    && socket_services.conversations[0].currentCampaignLambda.url_metadata.transferPhones
                    && socket_services.conversations[0].currentCampaignLambda.url_metadata.transferPhones.length > 0 ">
                        <ng-container
                            *ngIf="!socket_services.evalCallTransferParticipant({transferParticipant: socket_services.conversations[socket_services.conversations.length-1].transferParticipant, states: ['connected', 'dialing']})">
                            <div class="col-2">
                                <p style="margin-bottom: 0px !important;padding-bottom: 0px !important;">Transferir a:
                                </p>
                                <select style="width: 100%;" name="phoneList"
                                    [(ngModel)]="socket_services.transferPhone">
                                    <option value=''>Seleccionar Número</option>
                                    <option
                                        *ngFor="let item of socket_services.conversations[0].currentCampaignLambda.url_metadata.transferPhones"
                                        [value]='item.phone'>
                                        {{item.name}}</option>
                                </select>
                            </div>
                            <div class="col-1">
                                <button class="btn btn-success estiloBoton"
                                    (click)="socket_services.addConsult({ conversationId: socket_services.conversations[socket_services.conversations.length-1].id, phone: socket_services.transferPhone, name: socket_services.transferPhone, participantId: socket_services.conversations[socket_services.conversations.length-1].customer.participantId })"
                                    [disabled]='!socket_services.transferPhone'>
                                    <i class="fas fa-phone estiloIcono"></i>
                                    <p>Transferencia asistida</p>
                                </button>
                            </div>
                        </ng-container>
                        <ng-container
                            *ngIf="socket_services.evalCallTransferParticipant({transferParticipant: socket_services.conversations[socket_services.conversations.length-1].transferParticipant, states: ['connected']})">
                            <div class="col-2">
                                <p style="margin: 0 0 2px 0; text-align: center; font-weight: bold; font-size: 11px;">
                                    Teclado DTMF</p>
                                <div class="card" style="padding: 2px; border: 1px solid #dee2e6;">
                                    <div *ngFor="let row of dtmfKeypad"
                                        style="display: flex; justify-content: center; margin-bottom: 1px;">
                                        <button *ngFor="let digit of row" class="btn btn-outline-primary" (click)="socket_services.sendtDTMF({
                                                    conversationId: socket_services.conversations[socket_services.conversations.length-1].id,
                                                    transferParticipant: socket_services.conversations[socket_services.conversations.length-1].agentParticipant,
                                                    digitDTMF: digit,
                                                    agentParticipant: socket_services.conversations[socket_services.conversations.length-1].agentParticipant,
                                                    customer: socket_services.conversations[socket_services.conversations.length-1].customer
                                                })"
                                            style="width: 26px; height: 26px; font-size: 14px; font-weight: bold; padding: 0; margin: 0 1px; border-width: 1px; line-height: 1;">
                                            {{digit}}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="col-2">
                                <button class="btn btn-success estiloBoton"
                                    (click)="socket_services.disconnectParticipant(socket_services.conversations[socket_services.conversations.length-1].id, socket_services.conversations[socket_services.conversations.length-1].agentParticipant.id)">
                                    <i class="fas fa-arrow-right estiloIcono"></i>
                                    <i class="fas fa-phone estiloIcono"></i>
                                    <p>Transferir cliente</p>
                                </button>
                            </div>
                        </ng-container>
                        <ng-container
                            *ngIf="socket_services.evalCallTransferParticipant({transferParticipant: socket_services.conversations[socket_services.conversations.length-1].transferParticipant, states: ['connected', 'dialing']})">
                            <div class="col-2 float-right" style="float: right;">
                                <button class="btn btn-danger estiloBoton"
                                    (click)="socket_services.deleteConsult(socket_services.conversations[socket_services.conversations.length-1].id, socket_services.conversations[socket_services.conversations.length-1].customer.participantId)">
                                    <i class="fas fa-phone-slash estiloIcono"></i>
                                    <p>Cancelar Transferencia</p>
                                </button>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="socket_services.conversations[0].currentCampaignLambda.url_ivr">
                        <div *ngIf="!socket_services.conversations[socket_services.conversations.length-1].ivrParticipant || socket_services.conversations[socket_services.conversations.length-1].ivrParticipant.endTime"
                            class="col-1">
                            <button class="btn btn-primary estiloBoton"
                                (click)="socket_services.createSecureIVR(false,socket_services.conversations[socket_services.conversations.length-1])">
                                <i class="fas fa-lock estiloIcono"></i>
                                <i class="fas fa-satellite-dish estiloIcono"></i>
                                <p>IVR</p>
                            </button>
                        </div>
                    </ng-container>

                    <ng-container
                        *ngIf="socket_services.conversations[0].currentCampaignLambda.url_transfer && socket_services.conversations[0].saleFormComplete">
                        <div class="col-2">
                            <button class="btn btn-primary estiloBoton"
                                (click)="consult(socket_services.conversations[socket_services.conversations.length-1])"
                                style="width: 120px;">
                                <i class="fas fa-plus estiloIcono"></i>
                                <i class="fas fa-phone estiloIcono"></i>
                                <p>Transferir a cola</p>
                            </button>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container
                    *ngIf="socket_services.conversations[socket_services.conversations.length-1].state=='connected' 
                            || socket_services.conversations[socket_services.conversations.length-1].state=='dialing'  
                            || socket_services.conversations[socket_services.conversations.length-1].state=='contacting'
                            || (socket_services.conversations[socket_services.conversations.length-1].state=='disconnected' && socket_services.conversations[socket_services.conversations.length-1].agentParticipant.calls)">
                    <div class="col-2 float-right" style="float: right;">
                        <button class="btn btn-danger estiloBoton"
                            (click)="endCall(socket_services.conversations[socket_services.conversations.length-1])">
                            <i class="fas fa-phone-slash estiloIcono"></i>
                            <p>Cortar Llamada</p>
                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="socket_services.conversations[0].currentCampaignLambda.url_recall 
                    && socket_services.conversations[socket_services.conversations.length-1].state=='terminated' 
                    && socket_services.conversations[0].agentParticipant.calls ">
                    <div class="col-2">
                        <p style="margin-bottom: 0px !important;padding-bottom: 0px !important;">Número a
                            llamar: </p>
                        <select style="width: 100%;" *ngIf="socket_services.conversations[0].phoneList 
                            && socket_services.conversations[0].phoneList.length > 0" name="phoneList"
                            [(ngModel)]="socket_services.phoneSelected">
                            <option value=''>Seleccionar Número</option>
                            <option *ngFor="let item of socket_services.conversations[0].phoneList" [value]='item'>
                                {{item}}</option>
                        </select>
                    </div>
                    <!-- en esta seccion deberia ingresar el ngif -->
                    <div class="col-2" *ngIf="socket_services.conversations[0].currentCampaignLambda.url_metadata.freeCall">
                            <p style="margin-bottom: 0px !important;padding-bottom: 0px !important;">Número a
                            llamar manual: </p>
                            <input [(ngModel)]="telefonoRellamada" />
                    </div>
                    <div class="col-1">
                        <button class="btn btn-success estiloBoton" (click)="reCall()"
                            [disabled]='!socket_services.phoneSelected && !telefonoRellamada'>
                            <i class="fas fa-phone estiloIcono"></i>
                            <p>Rellamar Registro</p>
                        </button>
                    </div>
                </ng-container>


                <!-- <ng-container *ngIf="socket_services.conversations[0].currentCampaignLambda.url_recall 
                    && socket_services.conversations[socket_services.conversations.length-1].state=='terminated' 
                    && socket_services.conversations[0].agentParticipant.calls ">
                    <div class="col-2">
                        <p style="margin-bottom: 0px !important;padding-bottom: 0px !important;">Número a
                            llamar: </p>
                        <input type="number" min="0" max="100" step="1"/>
                        </div>
                    <div class="col-1">
                        <button class="btn btn-success estiloBoton" (click)="reCall()"
                            [disabled]='!socket_services.phoneSelected'>
                            <i class="fas fa-phone estiloIcono"></i>
                            <p>LLAMAR</p>
                        </button>
                    </div>
                </ng-container> -->
            </div>
        </ng-container>

        <div [class]="data_user && data_user.email && data_user.showBaltoDiv ? 'col-9' : 'col-12'">
            <ng-container
                *ngIf="socket_services.conversations.length > 0 && socket_services.conversations[0].id && socket_services.conversations[0].id!='' ;else conversationNoExist">
                <div class="row" style="justify-content: center;">
                    <div class="col-12">
                        <ng-container *ngIf="socket_services.conversations[0].currentCampaignLambda.url_dom_genesys
                                 && data_user.id
                                 && socket_services.conversations[0].currentContact.data
                                 && socket_services.conversations[0].currentContact.data.con_id
                                 && socket_services.conversations[0].id
                                 && socket_services.conversations[0].currentCampaignLambda.url_genesys_campaing_id
                                 && socket_services.conversations[0].customer.phone
                                 && socket_services.conversations[0].queueId ; else inboundCall">

                            <iframe class="estiloIframe" id="s3Frame" width="100%" height="700" [src]="socket_services.conversations[0].currentCampaignLambda.url_dom_genesys
                                    +'users/'+data_user.id
                                    +'/idcontacto/'+socket_services.conversations[0].currentContact.data.con_id
                                    +'/idinteraccion/'+socket_services.conversations[0].id
                                    +'/idcampana/'+socket_services.conversations[0].currentCampaignLambda.url_genesys_campaing_id
                                    +'/idcontactogenesys/'+socket_services.conversations[0].currentContact.data.con_id
                                    +'/fono/'+socket_services.conversations[0].customer.phone
                                    +'/cola/'+socket_services.conversations[0].queueId| safeUrl">
                            </iframe>
                        </ng-container>
                        <!-- Revisar -->
                        <ng-template #inboundCall>
                            <ng-container
                                *ngIf="socket_services.conversations[0].currentCampaignLambda.url_dom_genesys
                                            && data_user.id
                                            && socket_services.conversations[0].id
                                            && socket_services.conversations[0].currentCampaignLambda.url_genesys_campaing_id
                                            && socket_services.conversations[0].customer.phone
                                            && socket_services.conversations[0].queueId
                                            && (socket_services.conversations[0].mediaType == 'call-inbound' || socket_services.conversations[0].mediaType == 'callback')">
                                <iframe class="estiloIframe" id="s3Frame" width="100%" height="700"
                                    [src]="socket_services.conversations[0].currentCampaignLambda.url_dom_genesys
                                                            +'users/'+data_user.id
                                                            +'/idcontacto/'+socket_services.conversations[0].id
                                                            +'/idinteraccion/'+socket_services.conversations[0].id
                                                            +'/idcampana/'+socket_services.conversations[0].currentCampaignLambda.url_genesys_campaing_id
                                                            +'/idcontactogenesys/'+socket_services.conversations[0].id
                                                            +'/fono/'+socket_services.conversations[0].customer.phone
                                                            +'/cola/'+socket_services.conversations[0].queueId| safeUrl">
                                </iframe>
                            </ng-container>
                        </ng-template>
                    </div>
                    <!-- Agendamiento -->
                    <div style="text-align: -webkit-center;width: 100%;align-items: center;margin-bottom: 30px;justify-content: center;"
                        class="row">
                        <hr class="separador">
                        <ng-container
                            *ngIf="socket_services.conversations[0].wrapupCodes && areConversationsFinished()">
                            <div class="col-4" style="width: 100%;height: 100%;">
                                <h2>Código de conclusión:</h2>
                                <div style="width: 100%;height: 100%;">
                                    <div *ngIf="!socket_services.conversations[0].formComplete"
                                        class="col-12 card bg-danger">
                                        <p>Falta completar formulario</p>
                                    </div>
                                    <div *ngIf="socket_services.conversations[0].formComplete" class="card"
                                        style="width: 100%;">
                                        <select name="ddl" [(ngModel)]="socket_services.wrapup_code_selected"
                                            size="number_of_options">
                                            <option value=''>INGRESE UN C. DE CONCLUSIÓN</option>
                                            <ng-container
                                                *ngFor="let item of socket_services.conversations[0].wrapupCodes">
                                                <option *ngIf="item.id != socket_services.id_cc_rellamada"
                                                    [value]='item.id'>
                                                    {{item.name}}
                                                </option>
                                            </ng-container>
                                        </select>
                                    </div>
                                    <br>
                                    <button *ngIf="socket_services.conversations[0].formComplete"
                                        class="btn btn-primary estiloBoton" (click)='wrapupCode(item)'
                                        style="height: 60px !important;">Listo</button>
                                </div>
                            </div>
                        </ng-container>
                        <div class="col-8">
                            <ng-container
                                *ngIf="socket_services.conversations[0].mediaType != 'call-inbound' 
                            || (socket_services.conversations[0].currentContact.data && socket_services.conversations[0].currentContact.data.con_id)">
                                <h2>Agendamiento</h2>
                                <div class="row" style="align-items: center; width: 100%;">
                                    <div *ngIf="data_user.skills.length > 0" class="col-3">
                                        <p
                                            style="margin-bottom: 0px !important;padding-bottom: 0px !important;text-align: start;">
                                            Tipo de
                                            agendamiento:
                                        </p>
                                    </div>
                                    <div *ngIf="data_user.skills.length > 0" class="col-9" style="text-align: start;">
                                        <select name="preference" id="preference"
                                            [(ngModel)]="socket_services.callBackPreference">
                                            <option value="">Seleccione a quien se dirige el agendamiento</option>
                                            <!-- <option value="preference">Preferente a mi</option> -->
                                            <option *ngFor="let item of data_user.skills" [value]="item.id">Dirigido a:
                                                {{item.name}}
                                            </option>
                                        </select>
                                    </div>
                                    <br><br>
                                    <div class="col-3">
                                        <p
                                            style="margin-bottom: 0px !important;padding-bottom: 0px !important;text-align: start;">
                                            Fecha
                                            agendamiento:
                                        </p>

                                    </div>


                                    <div class="col-9">
                                        <ngbd-datepicker-popup (messageEvent)='clickDate($event)'>
                                        </ngbd-datepicker-popup>
                                    </div>
                                    <div class="col-3">
                                    </div>
                                    <div class="col-9">
                                        <div class="row" style="padding: 15px;">
                                            <div><input type="number" placeholder="HH" class="inputNumeros" min="0"
                                                    max="23" [(ngModel)]="callbackHour.hour"></div>
                                            <div>
                                                <p> : </p>
                                            </div>
                                            <div><input type="number" placeholder="MM" class="inputNumeros" min="0"
                                                    max="59" [(ngModel)]="callbackHour.minute"></div>
                                            <div>
                                                <p style="margin-left: 5px;"> Hrs. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <br><br>
                                    <br><br>
                                    <div class="col-3">
                                        <p
                                            style="margin-bottom: 0px !important;padding-bottom: 0px !important;text-align: start;">
                                            Observaciones:
                                        </p>
                                    </div>
                                    <div class="col-9">
                                        <!-- <input class=" estiloBotonLlamado" style="border-style: solid;" type="text" id="motivo_agendamiento" name="motivo_agendamiento" [(ngModel)]="motivo_agendamiento" placeholder="Notas"> -->
                                        <textarea class=" estiloBotonLlamado" style="border-style: solid;" type="text"
                                            id="motivo_agendamiento" name="motivo_agendamiento"
                                            [(ngModel)]="motivo_agendamiento"
                                            placeholder="Ingrese aquí sus observaciones." rows="4"
                                            maxlength="99"></textarea>
                                        <p style="float: right;">{{motivo_agendamiento.length}}/99</p>
                                    </div>
                                    <div class="col-12" style="height: 70px;">
                                        <button *ngIf="true" class="btn btn-primary estiloBoton"
                                            (click)="CallbackProgramado()"
                                            [disabled]='socket_services.conversations[0].callback'>Agendar
                                            llamado</button>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                    </div>
                </div>
            </ng-container>

            <ng-template #conversationNoExist>

                <div class="divPantallaSinLlamado">
                    <br><br><br><br><br><br>
                    <h1 *ngIf="routing_status!='ELEGIBLE A LLAMADOS';else esperandoLlamado"
                        class="tituloPantallaSinLlamado">
                        "Póngase en cola, o hacer elegible a llamados."</h1>
                    <ng-template #esperandoLlamado>
                        <h1 class="tituloPantallaSinLlamado">Esperando a que caiga un registro</h1><br>
                        <i class="fas fa-spinner fa-spin estiloSpinner"></i>
                    </ng-template>
                </div>
            </ng-template>

        </div>
        <ng-container *ngIf="data_user && data_user.email && data_user.showBaltoDiv">
            <div class="col-3">
                <iframe [src]="'https://app.baltocloud.com/?userid='+data_user.email+'&desktopKey=baltochile'| safeUrl"
                    style="width: 100%; height: 700px;"></iframe>
            </div>
        </ng-container>
    </div>
</div>







<!-- Modal -->
<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <!-- <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Mis agendamientos</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div> -->
            <div class="modal-body">
                <div *ngIf="callbackLoading">
                    <i class="fas fa-spinner fa-spin estiloSpinner"></i>

                </div>
                <app-callbacks-table *ngIf="!callbackLoading" [loading]='callbackLoading'
                    [ELEMENT_DATA]='callBackArray' (onEditCallback)="handleEditCallback($event)"></app-callbacks-table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalSales" tabindex="-1" role="dialog" aria-labelledby="modalSalesTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div *ngIf="loadingSales">
                    <i class="fas fa-spinner fa-spin estiloSpinner"></i>

                </div>
                <app-sales-table *ngIf="!loadingSales" [loading]='loadingSales'
                    [ELEMENT_DATA]='salesArray'></app-sales-table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalCallbacks" tabindex="-1" role="dialog" aria-labelledby="modalCallbacksTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title">Agendamientos de la llamada:</h2>
            </div>
            <div class="modal-body">
                <div *ngIf="socket_services.callBackList.length > 0" style="margin-bottom: 15px;">
                    <h4>Observaciones:</h4>
                    <hr class="estiloObservaciones">
                    <ng-container *ngFor="let item of socket_services.callBackList">
                        <p class="estiloObservaciones"
                            *ngIf="!item.jso_cb_metadata.dialerContactId;else nuevoAgendamiento">
                            {{item.jso_cb_metadata}}</p>
                        <ng-template #nuevoAgendamiento>
                            <p class="estiloObservaciones">Tipo: {{item.jso_cb_metadata.tipo}}</p>
                            <p class="estiloObservaciones">Para: {{item.jso_cb_metadata.dateString}}</p>
                            <p class="estiloObservaciones">Observación: {{item.jso_cb_metadata.observacion}}</p>
                        </ng-template>
                        <hr class="estiloObservaciones">
                    </ng-container>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>